import { render, staticRenderFns } from "./AddVenturaAdmin.vue?vue&type=template&id=4e673ffe&scoped=true&"
import script from "./AddVenturaAdmin.vue?vue&type=script&lang=js&"
export * from "./AddVenturaAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e673ffe",
  null
  
)

export default component.exports